import { config } from "./config";
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

const app = initializeApp(config.firebase);

export const auth = getAuth(app);
export default app;
